import { useStoreon } from 'storeon/react';
import { LoyaltyRegistrationModalStore } from '../../../reducers';
import { useEffectOnce } from 'common/hooks';
import { REGISTRATION_MODAL } from '../../../actions';

export const OPEN_LOYALTY_REGISTRATION_MODAL_EVENT = 'OPEN_LOYALTY_REGISTRATION_MODAL';

export const useLoyaltyRegistrationModalEvents = () => {
  const { dispatch } = useStoreon<LoyaltyRegistrationModalStore>('loyaltyRegistrationModal');

  useEffectOnce(() => {
    const openModal = () => {
      dispatch(REGISTRATION_MODAL.open);
    };

    window.addEventListener(OPEN_LOYALTY_REGISTRATION_MODAL_EVENT, openModal);

    return () => {
      window.removeEventListener(OPEN_LOYALTY_REGISTRATION_MODAL_EVENT, openModal);
    };
  });
};
